import React, { useMemo } from "react";

import { Tooltip } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { StarSlash } from "iconsax-react";
import { Task } from "Models/task";
import { getUserDateTimeFormatPattern } from "Util/dateFormaterPreference";
import { getCompleteDateRangeLabel } from "Util/startDate";

import { TaskBadgeProps } from "../types";
import { Container, Divider, TimeLabel, TitleLabel } from "./styles";
import { useAppState } from "Context/StateContext";

export const TaskBadgeMonth: React.FC<TaskBadgeProps> = (props) => {
  const { style, event, onSelectEvent, viewMode } = props;
  const { currentUser, formatWithUserTimezone } = useAppState();

  const isAssigned = useMemo(() => {
    const task = event.resource.task as Task;

    return !!(task?.team?.memberLeader && task.team?.members?.length);
  }, [event]);

  const isMonth = viewMode === "month";

  const isVip = useMemo(() => {
    return event.resource.order.vipTreatment;
  }, [event]);

  const date = event.start ? new Date(event.start) : null;

  const tooltip = date
    ? formatWithUserTimezone(date, getUserDateTimeFormatPattern(currentUser?.preferences))
    : "";

  const badgeWeekOrDayStyle: React.CSSProperties = {
    position: isMonth ? "relative" : "absolute",
    top: isMonth ? "0" : `calc(${style?.top || 0}% - 0px)`,
  };

  const dateRanged = useMemo(() => {
    return getCompleteDateRangeLabel({
      startDate: event.start,
      endDate: event.end,
      separator: "-",
      preferences: currentUser?.preferences,
    });
  }, [event, currentUser?.preferences]);

  return (
    <Tooltip title={tooltip}>
      <Container
        data-cy="taskBadgeMonth"
        onClick={(htmlEvent) => onSelectEvent?.(event, htmlEvent)}
        isVip={isVip}
        isAssigned={isAssigned}
        style={badgeWeekOrDayStyle}
      >
        <Divider orientation="vertical" flexItem />

        {isVip && <StarSlash size={16} color={colors.rose800} fill={colors.white} variant="Bold" />}

        <TitleLabel className="task-badge__title-label">{event.title}</TitleLabel>

        <TimeLabel>{dateRanged}</TimeLabel>
      </Container>
    </Tooltip>
  );
};
